var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mat40" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row admin-header" }, [
        _vm._m(0),
        _c("div", { staticClass: "col-12 col-md-8" }, [
          _c(
            "div",
            { staticClass: "buttons-wrap" },
            [
              _c("base-input-text", {
                staticClass: "admin-header__search",
                attrs: { icon: "fas fa-search", label: "Szukaj..." },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
              _c(
                "base-button",
                {
                  staticClass: "admin-header__export",
                  attrs: {
                    btn9: "",
                    icon: "dsi dsi-download",
                    disabled: !_vm.ready,
                  },
                  on: { click: _vm.exportCsv },
                },
                [_vm._v(" Pobierz ")]
              ),
              _c(
                "base-button-group",
                {
                  staticClass: "admin-header__views",
                  attrs: { horizontal: "" },
                },
                [
                  _c(
                    "base-button",
                    {
                      staticClass: "admin-header__views-btn",
                      attrs: { btn11: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$router.push({
                            name: "panel-provision-admin",
                            alias: true,
                          })
                        },
                      },
                    },
                    [_vm._v(" Płatności ")]
                  ),
                  _c(
                    "base-button",
                    {
                      staticClass: "admin-header__views-btn",
                      attrs: { btn11: "", pressed: true },
                      on: {
                        click: function ($event) {
                          return _vm.$router.push({
                            name: "panel-provision-agreements-admin",
                            alias: true,
                          })
                        },
                      },
                    },
                    [_vm._v(" Umowy ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
    !_vm.ready
      ? _c("div", { staticClass: "mat32" }, [_vm._m(1)])
      : _c(
          "div",
          {
            staticClass: "row container-list",
            class: { "action-open": _vm.actionOpen },
          },
          [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                { ref: "list" },
                [
                  _c("base-table", {
                    staticClass: "list",
                    attrs: {
                      headers: _vm.tableHeaders,
                      items: _vm.items,
                      search: _vm.search,
                      "multi-sort-enabled": true,
                      "multi-sort-default": _vm.defaultMultiSort,
                      "ignore-empty-sort": true,
                      "sort-reverse-default": true,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function ({ sort }) {
                          return [
                            _c(
                              "tr",
                              { staticClass: "list__row" },
                              _vm._l(
                                _vm.tableHeaders,
                                function (header, column) {
                                  return _c(
                                    "th",
                                    {
                                      key: column,
                                      staticClass: "list__row-header",
                                      on: {
                                        click: function ($event) {
                                          return sort(column)
                                        },
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(header.text) + " ")]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        },
                      },
                      {
                        key: "body",
                        fn: function ({ displayedItems }) {
                          return _vm._l(displayedItems, function (item) {
                            return _c(
                              "tr",
                              {
                                key: item.id,
                                staticClass: "list__row",
                                class: {
                                  "list__row--overtime": item.overDate,
                                  "list__row--payed": item.payed,
                                  "list__row--notpayed": !item.payed,
                                },
                              },
                              _vm._l(
                                _vm.tableHeaders,
                                function (header, column) {
                                  return _c(
                                    "td",
                                    {
                                      key: column,
                                      staticClass: "list__row-data",
                                      class: {
                                        "list__row-data--name":
                                          header.value === "competitionName",
                                        "list__row-data--loading": _vm.loading,
                                        "list__row-data--date":
                                          item[header.value] ===
                                          item.paymentDate,
                                        "list__row-data--payed":
                                          item[header.value] === item.payed,
                                      },
                                      on: {
                                        click: function ($event) {
                                          header.value === "more"
                                            ? _vm.menuClickHandler(
                                                $event,
                                                item.id
                                              )
                                            : ""
                                        },
                                      },
                                    },
                                    [
                                      header.value === "more"
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                ref: item.id,
                                                refInFor: true,
                                                staticClass: "more-btn",
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-ellipsis-v",
                                                }),
                                                _vm.menuCompetitionId ===
                                                item.id
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "more-btn__content",
                                                        class: {
                                                          "more-btn__content--from-up":
                                                            _vm.isMenuCompetitionIdInBottom,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "more-btn__content-btn",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.$router.push(
                                                                  {
                                                                    name: "panel-setting-new-info-payments",
                                                                    params: {
                                                                      name: item.organizer,
                                                                      id: item.id,
                                                                    },
                                                                    alias: true,
                                                                  }
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "svg",
                                                              {
                                                                staticClass:
                                                                  "mar8",
                                                                attrs: {
                                                                  width: "24",
                                                                  height: "24",
                                                                  viewBox:
                                                                    "0 0 24 24",
                                                                  fill: "none",
                                                                  xmlns:
                                                                    "http://www.w3.org/2000/svg",
                                                                },
                                                              },
                                                              [
                                                                _c("path", {
                                                                  attrs: {
                                                                    "fill-rule":
                                                                      "evenodd",
                                                                    "clip-rule":
                                                                      "evenodd",
                                                                    d: "M10 3.5C10 3.77614 10.2239 4 10.5 4H18.5C19.3284 4 20 4.67157 20 5.5V18.5C20 19.3284 19.3284 20 18.5 20H10.5C10.2239 20 10 20.2239 10 20.5C10 20.7761 10.2239 21 10.5 21H18.5C19.8807 21 21 19.8807 21 18.5V5.5C21 4.11929 19.8807 3 18.5 3H10.5C10.2239 3 10 3.22386 10 3.5ZM3.5 12H14.2929L11.1464 15.1464C10.9512 15.3417 10.9512 15.6583 11.1464 15.8536C11.3417 16.0488 11.6583 16.0488 11.8536 15.8536L15.8536 11.8536C16.0488 11.6583 16.0488 11.3417 15.8536 11.1464L11.8536 7.14645C11.6583 6.95118 11.3417 6.95118 11.1464 7.14645C10.9512 7.34171 10.9512 7.65829 11.1464 7.85355L14.2929 11H3.5C3.22386 11 3 11.2239 3 11.5C3 11.7761 3.22386 12 3.5 12Z",
                                                                    fill: "#455A64",
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              " Przejdź do ustawień organizatora "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        : header.value === "payAgreements"
                                        ? [
                                            item.payAgreements
                                              ? _c("span", [
                                                  _c("img", {
                                                    staticClass: "icon",
                                                    attrs: {
                                                      src: require("@/assets/images/icons/checkmark-circle.svg"),
                                                    },
                                                  }),
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href:
                                                          "https://dostartu.pl/" +
                                                          item.payAgreements,
                                                        target: "_blank",
                                                      },
                                                    },
                                                    [_vm._v("Podpisana")]
                                                  ),
                                                ])
                                              : _c("span", [
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass: "icon",
                                                      attrs: {
                                                        width: "16",
                                                        height: "16",
                                                        viewBox: "0 0 16 16",
                                                        fill: "none",
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          d: "M2.5 2.53125C4.02083 1.01042 5.85417 0.25 8 0.25C10.1458 0.25 11.9688 1.01042 13.4688 2.53125C14.9896 4.03125 15.75 5.85417 15.75 8C15.75 10.1458 14.9896 11.9792 13.4688 13.5C11.9688 15 10.1458 15.75 8 15.75C5.85417 15.75 4.02083 15 2.5 13.5C1 11.9792 0.25 10.1458 0.25 8C0.25 5.85417 1 4.03125 2.5 2.53125ZM3.5625 12.4375C4.79167 13.6458 6.27083 14.25 8 14.25C9.72917 14.25 11.1979 13.6458 12.4062 12.4375C13.6354 11.2083 14.25 9.72917 14.25 8C14.25 6.27083 13.6354 4.80208 12.4062 3.59375C11.1979 2.36458 9.72917 1.75 8 1.75C6.27083 1.75 4.79167 2.36458 3.5625 3.59375C2.35417 4.80208 1.75 6.27083 1.75 8C1.75 9.72917 2.35417 11.2083 3.5625 12.4375ZM11.1875 6.0625L9.25 8L11.1875 9.9375C11.3542 10.125 11.3542 10.3021 11.1875 10.4688L10.4688 11.1875C10.3021 11.3542 10.125 11.3542 9.9375 11.1875L8 9.25L6.0625 11.1875C5.875 11.3542 5.69792 11.3542 5.53125 11.1875L4.8125 10.4688C4.64583 10.3021 4.64583 10.125 4.8125 9.9375L6.75 8L4.8125 6.0625C4.64583 5.875 4.64583 5.69792 4.8125 5.53125L5.53125 4.8125C5.69792 4.64583 5.875 4.64583 6.0625 4.8125L8 6.75L9.9375 4.8125C10.125 4.64583 10.3021 4.64583 10.4688 4.8125L11.1875 5.53125C11.3542 5.69792 11.3542 5.875 11.1875 6.0625Z",
                                                          fill: "#455A64",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" Niepodpisana "),
                                                ]),
                                          ]
                                        : header.value === "approved"
                                        ? [
                                            _c("base-input-switch", {
                                              attrs: { checked: item.approved },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.updateApproved(
                                                    $event,
                                                    item.id
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        : header.value === "notes"
                                        ? [
                                            _c("v-dropdown", {
                                              attrs: { distance: 6 },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function () {
                                                      return [
                                                        (
                                                          item.notes || ""
                                                        ).trim().length > 0
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "tooltip-trigger",
                                                              },
                                                              [
                                                                _c(
                                                                  "svg",
                                                                  {
                                                                    staticClass:
                                                                      "svgicon",
                                                                    attrs: {
                                                                      xmlns:
                                                                        "http://www.w3.org/2000/svg",
                                                                      viewBox:
                                                                        "0 0 448 512",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("path", {
                                                                      attrs: {
                                                                        d: "M312 320h136V56c0-13.3-10.7-24-24-24H24C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h264V344c0-13.2 10.8-24 24-24zm129 55l-98 98c-4.5 4.5-10.6 7-17 7h-6V352h128v6.1c0 6.3-2.5 12.4-7 16.9z",
                                                                      },
                                                                    }),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "tooltip-trigger",
                                                              },
                                                              [
                                                                _c(
                                                                  "svg",
                                                                  {
                                                                    staticClass:
                                                                      "svgicon",
                                                                    attrs: {
                                                                      xmlns:
                                                                        "http://www.w3.org/2000/svg",
                                                                      viewBox:
                                                                        "0 0 448 512",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("path", {
                                                                      attrs: {
                                                                        d: "M448 348.106V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80v351.988c0 26.51 21.49 48 48 48h268.118a48 48 0 0 0 33.941-14.059l83.882-83.882A48 48 0 0 0 448 348.106zm-128 80v-76.118h76.118L320 428.106zM400 80v223.988H296c-13.255 0-24 10.745-24 24v104H48V80h352z",
                                                                      },
                                                                    }),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                  {
                                                    key: "popper",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "tooltip-wrapper",
                                                          },
                                                          [
                                                            _c("textarea", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    item.notes,
                                                                  expression:
                                                                    "item.notes",
                                                                },
                                                              ],
                                                              attrs: {
                                                                placeholder:
                                                                  "Dodaj notatkę",
                                                              },
                                                              domProps: {
                                                                value:
                                                                  item.notes,
                                                              },
                                                              on: {
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    )
                                                                      return
                                                                    _vm.$set(
                                                                      item,
                                                                      "notes",
                                                                      $event
                                                                        .target
                                                                        .value
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                            _c(
                                                              "button",
                                                              {
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateNote(
                                                                        item.notes,
                                                                        item.id
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fas fa-check",
                                                                }),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ]
                                        : [
                                            _vm._v(
                                              " " +
                                                _vm._s(item[header.value]) +
                                                " "
                                            ),
                                          ],
                                    ],
                                    2
                                  )
                                }
                              ),
                              0
                            )
                          })
                        },
                      },
                      {
                        key: "no-results",
                        fn: function ({ search: term }) {
                          return [
                            term.length
                              ? _c("div", [
                                  _vm._v(" Brak wyników wyszukiwania "),
                                  _c("b", [_vm._v(_vm._s(term))]),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ]),
          ]
        ),
    _vm.ready
      ? _c(
          "div",
          { staticClass: "row admin__pages", staticStyle: { display: "none" } },
          [
            _c(
              "div",
              {
                staticClass: "admin__pages-btn",
                class: {
                  "admin__pages-btn--disabled": !_vm.isPreviousPage,
                },
                on: {
                  click: function ($event) {
                    _vm.isPreviousPage ? _vm.prevPage() : ""
                  },
                },
              },
              [
                _vm.isLoadingPrev
                  ? _c("div", { staticClass: "admin__pages-loading" }, [
                      _vm._m(2),
                    ])
                  : _vm._e(),
                _vm._v(" Poprzednie "),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "admin__pages-btn",
                class: { "admin__pages-btn--disabled": !_vm.isNextPage },
                on: {
                  click: function ($event) {
                    _vm.isNextPage ? _vm.nextPage() : ""
                  },
                },
              },
              [
                _vm.isLoadingNext
                  ? _c("div", { staticClass: "admin__pages-loading" }, [
                      _vm._m(3),
                    ])
                  : _vm._e(),
                _vm._v(" Następne "),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 col-md-4" }, [
      _c("h1", [_vm._v("Lista umów")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "admin-header__loading-state" }, [
          _vm._v(" Trwa wczytywanie "),
          _c("div", { staticClass: "mal15 lds-ellipsis" }, [
            _c("div"),
            _c("div"),
            _c("div"),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "lds-ellipsis" }, [
      _c("div"),
      _c("div"),
      _c("div"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "lds-ellipsis" }, [
      _c("div"),
      _c("div"),
      _c("div"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }